import { render, staticRenderFns } from "./SideMenuTeacher.vue?vue&type=template&id=4b3b53da&scoped=true"
import script from "./SideMenuTeacher.vue?vue&type=script&lang=js"
export * from "./SideMenuTeacher.vue?vue&type=script&lang=js"
import style0 from "./SideMenuTeacher.vue?vue&type=style&index=0&id=4b3b53da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3b53da",
  null
  
)

export default component.exports